import $ from "jquery";
import moment from "moment";

/**
 * DateRangePicker with default options set
 * @param options
 */
export function dateRangePicker(options) {
    let dateRangePickerOptions = {
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        locale: {
            format: 'YYYY-MM-DD'
        },
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }
    if (options.minDate !== undefined) {
        dateRangePickerOptions.minDate = options.minDate;
    }
    if (options.maxDate !== undefined) {
        dateRangePickerOptions.maxDate = options.maxDate;
    }
    $(`${options.selector}`).daterangepicker(dateRangePickerOptions, function (start, end, label) {
        $(`${options.selector}`).val(start.format('YYYY-MM-DD') + ' - ' + end.format('YYYY-MM-DD'));
    });
}
